<!-- Button trigger modal -->
<button id="openModalButton" type="button" [hidden]="true" class="btn btn-primary" data-bs-toggle="modal"
  data-bs-target="#staticBackdrop">
  {{ "modal_open" | translate }}
</button>

<!-- Modal -->
<div class="modal fade blured-overlay" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
  aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl">
    <div class="modal-content mfa-modal-content">
      <div class="modal-body mfa-header">
        <div class="mfa-img">
          <img src="../../../../assets/svg-icons/mfa-ico.svg" alt="" width="150px" />
          <h6 *ngIf="showMailOTPBox">
            {{ "we_have_sent_email_at" | translate }}
            <a [href]="'mailto:' + this.username">{{ this.username }}</a>
            {{ "with_a_code_otp" | translate }}
          </h6>
          <h6 *ngIf="showAuthenticatorBox">
            {{
            "open_your_translator_app_to_view_authentication"
            | translate
            }}
          </h6>
        </div>
        <div class="mfa-input">
          <input [ngClass]="{ 'otp-verified disabled': isValidOTPEntered }" type="text" numeric maxlength="1"
            [(ngModel)]="otp1" name="otp1" class="form-control form-input mr-3"
            [style.background-color]="mybgColorVaraible" [style.color]="myColorVaraible" (input)="validateOTP()"
            #digitOne (keyup)="onDigitInput($event)" [disabled]="isValidOTPEntered" />
          <input [ngClass]="{ 'otp-verified disabled': isValidOTPEntered }" type="text" numeric maxlength="1"
            name="otp2" [(ngModel)]="otp2" class="form-control form-input mr-3"
            [style.background-color]="mybgColorVaraible" [style.color]="myColorVaraible" (input)="validateOTP()"
            #digitTwo (keyup)="onDigitInput($event)" style="display: inline-block; width: 50px; height: 50px"
            [disabled]="isValidOTPEntered" />
          <input [ngClass]="{ 'otp-verified disabled': isValidOTPEntered }" type="text" numeric maxlength="1"
            [(ngModel)]="otp3" name="otp3" class="form-control form-input mr-3"
            [style.background-color]="mybgColorVaraible" [style.color]="myColorVaraible" (input)="validateOTP()"
            #digitThree (keyup)="onDigitInput($event)" [disabled]="isValidOTPEntered" />
          <input [ngClass]="{ 'otp-verified disabled': isValidOTPEntered }" type="text" numeric maxlength="1"
            [(ngModel)]="otp4" name="otp4" class="form-control form-input mr-3"
            [style.background-color]="mybgColorVaraible" [style.color]="myColorVaraible" (input)="validateOTP()"
            #digitFour (keyup)="onDigitInput($event)" [disabled]="isValidOTPEntered" />
          <input [ngClass]="{ 'otp-verified disabled': isValidOTPEntered }" type="text" numeric maxlength="1"
            [(ngModel)]="otp5" name="otp5" class="form-control form-input mr-3"
            [style.background-color]="mybgColorVaraible" [style.color]="myColorVaraible" (input)="validateOTP()"
            #digitFour (keyup)="onDigitInput($event)" [disabled]="isValidOTPEntered" />
          <input [ngClass]="{ 'otp-verified disabled': isValidOTPEntered }" type="text" numeric maxlength="1"
            [(ngModel)]="otp6" name="otp6" class="form-control form-input" [style.background-color]="mybgColorVaraible"
            [style.color]="myColorVaraible" (input)="validateOTP()" #digitFour (keyup)="onDigitInput($event)"
            [disabled]="isValidOTPEntered" />
        </div>
      </div>
      <div class="modal-footer d-block">
        <div class="d-flex justify-content-center mt-0">
          <button type="button" id="closeOTPModel" [hidden]="true" class="btn eod-btn-primary mb-3"
            data-bs-dismiss="modal">
            {{ "verify_login" | translate }}
          </button>
          <button type="button" (click)="verifyToken()" class="btn eod-btn-primary mb-3" *ngIf="showAuthenticatorBox">
            {{ "verify_login" | translate }}
          </button>
          <button type="button" (click)="resendOTP()" class="btn eod-btn-warning mr-2" *ngIf="showMailOTPBox">
            {{ "resend_otp" | translate }}
          </button>
          <button type="button" (click)="verifyOTPandLogin()" class="btn eod-btn-primary" *ngIf="showMailOTPBox"
            [ngClass]="{ disabled: !isValidOTPEntered }" data-bs-dismiss="modal">
            {{ "verify_login" | translate }}
          </button>
        </div>
        <div *ngIf="showAuthenticatorBox" class="ml-2">
          <h6 class="text-center">
            <span class="eod-text-grey-02">{{
              "having_problems" | translate
              }}</span>
            {{ "please" | translate }}
            <a (click)="resendOTP()" data-href="javascript:void(0)" class="eod-link-primary">{{ "click_here" | translate
              }}</a>
            {{ "to_send_a_code_via_email" | translate }}
          </h6>
        </div>
        <div *ngIf="!showAuthenticatorBox" class="ml-2 mt-4">
          <h6 class="text-center">
            <span class="eod-text-grey-02">{{
              "having_problems" | translate
              }}</span>
            {{ "please" | translate }}
            <a (click)="fnShowAuthenticatorBox()" data-href="javascript:void(0)" class="eod-link-primary">{{
              "click_here" | translate }}</a>
            {{ "to_verify_using_authenticator_instead" | translate }}
          </h6>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- MFA Popup  1 -->
<!-- Button trigger modal -->
<button [hidden]="true" id="openMFAOptionButton" type="button" class="btn btn-primary" data-bs-toggle="modal"
  data-bs-target="#mfaModal">
  Options of Authenticate
</button>
<!-- Modal -->
<div class="modal fade blured-overlay" id="mfaModal" tabindex="-1" aria-labelledby="mfaModalLabel" aria-hidden="true"
  data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog modal-dialog-centered select-option-mfa-dialog">
    <div class="modal-content">
      <div class="modal-header min-h-7em py-3 eod-bg-white border-0">
        <div class="w-97pc mt-3">
          <h1 class="modal-title f-24 text-center fw-700" id="mfaModalLabel">
            {{"select_one_of_the_options_to_authenticate" | translate}}
          </h1>
          <h6 class="text-center f-14">
            {{"this_is_to_conform_that_it_is_you" | translate}}
          </h6>
        </div>
        <button type="button" class="btn-close mt-3" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body pt-0">
        <div class="row">
          <div class="col-md-6 pl-0 pr-2">
            <div class="card h-100">
              <div class="card-header d-flex justify-content-between">
                <h5 class="fw-700 mb-0">{{"use_email_to_verify" | translate }}</h5>
                <i class="fas fa-envelope f-24"></i>
              </div>
              <div class="card-body d-flex flex-column">
                <p class="card-text mb-3 eod-text-grey-02">
                  {{"we_will_send_otp_code_to_email" | translate}}
                </p>
                <button (click)="resendOTP()" type="button" data-bs-dismiss="modal"
                  class="btn eod-btn-outline-secondary w-100pc mt-auto">
                  {{"verify_using_email" | translate}}
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-6 pl-2 pr-0">
            <div class="card h-100">
              <div class="card-header d-flex justify-content-between">
                <h5 class="fw-700 mb-0">{{"use_authenticator_app"| translate}}</h5>
                <div class="d-flex gap-1">
                  <img src="../../../assets/svg-icons/Microsoft_Authenticator.svg" alt="" />
                  <img src="../../../assets/svg-icons/Google_Authenticator.svg" alt="" />
                </div>
              </div>
              <div class="card-body d-flex flex-column">
                <p class="card-text mb-3 eod-text-grey-02">
                  {{"authenticator_app_provides" | translate}}
                </p>
                <button (click)="openMFARegistration()" type="button"
                  class="btn eod-btn-outline-secondary w-100pc mt-auto">
                  {{"verify_using_authenticator" | translate}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- MFA Popup End -->

<!-- MFA Popup  2 -->
<!-- Button trigger modal -->
<button [hidden]="true" type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#mfaModal2">
  Enter Code
</button>
<!-- Modal -->
<div class="modal fade blured-overlay" id="mfaModal2" tabindex="-1" aria-labelledby="mfaModal2Label" aria-hidden="true"
  data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content mfa-modal-content">
      <div class="modal-header min-h-7em py-3 eod-bg-white border-0">
        <div class="w-97pc mt-3">
          <h1 class="modal-title f-24 fw-700" id="mfaModal2Label">
            Enter Code
          </h1>
          <p class="f-14">
            We have sent you an email at <a href="mailto:sanity@yopmail.com"
              class="eod-link-primary">sanity&#64;yopmail.com</a> with a verification CODE / OTP
          </p>
        </div>
        <a class="mt-3 f-22" data-bs-dismiss="modal" aria-label="Close"><i class="fal fa-times"></i></a>
      </div>
      <div class="modal-body pt-0">
        <div class="mfa-input onboarding d-flex justify-content-start mb-2">
          <input [ngClass]="{ 'otp-verified disabled': isValidOTPEntered }" type="text" numeric maxlength="1"
            [(ngModel)]="otp1" name="otp1" class="form-control form-input mr-3 max-w-3em"
            [style.background-color]="mybgColorVaraible" [style.color]="myColorVaraible" (input)="validateOTP()"
            #digitOne (keyup)="onDigitInput($event)" [disabled]="isValidOTPEntered" />
          <input [ngClass]="{ 'otp-verified disabled': isValidOTPEntered }" type="text" numeric maxlength="1"
            name="otp2" [(ngModel)]="otp2" class="form-control form-input mr-3 max-w-3em"
            [style.background-color]="mybgColorVaraible" [style.color]="myColorVaraible" (input)="validateOTP()"
            #digitTwo (keyup)="onDigitInput($event)" style="display: inline-block; width: 50px; height: 50px"
            [disabled]="isValidOTPEntered" />
          <input [ngClass]="{ 'otp-verified disabled': isValidOTPEntered }" type="text" numeric maxlength="1"
            [(ngModel)]="otp3" name="otp3" class="form-control form-input mr-3 max-w-3em"
            [style.background-color]="mybgColorVaraible" [style.color]="myColorVaraible" (input)="validateOTP()"
            #digitThree (keyup)="onDigitInput($event)" [disabled]="isValidOTPEntered" />
          <input [ngClass]="{ 'otp-verified disabled': isValidOTPEntered }" type="text" numeric maxlength="1"
            [(ngModel)]="otp4" name="otp4" class="form-control form-input mr-3 max-w-3em"
            [style.background-color]="mybgColorVaraible" [style.color]="myColorVaraible" (input)="validateOTP()"
            #digitFour (keyup)="onDigitInput($event)" [disabled]="isValidOTPEntered" />
          <input [ngClass]="{ 'otp-verified disabled': isValidOTPEntered }" type="text" numeric maxlength="1"
            [(ngModel)]="otp5" name="otp5" class="form-control form-input mr-3 max-w-3em"
            [style.background-color]="mybgColorVaraible" [style.color]="myColorVaraible" (input)="validateOTP()"
            #digitFour (keyup)="onDigitInput($event)" [disabled]="isValidOTPEntered" />
          <input [ngClass]="{ 'otp-verified disabled': isValidOTPEntered }" type="text" numeric maxlength="1"
            [(ngModel)]="otp6" name="otp6" class="form-control form-input max-w-3em"
            [style.background-color]="mybgColorVaraible" [style.color]="myColorVaraible" (input)="validateOTP()"
            #digitFour (keyup)="onDigitInput($event)" [disabled]="isValidOTPEntered" />
        </div>
        <button type="button" class="btn eod-btn-secondary">
          Verify & Login
        </button>
      </div>
      <div *ngIf="showAuthenticatorBox" class="ml-2">
        <h6 class="text-center">
          <span class="eod-text-grey-02">{{
            "Having Problems?" | translate
            }}</span>
          {{ "please" | translate }}
          <a (click)="resendOTP()" data-href="javascript:void(0)" class="eod-link-primary">{{ "click here" | translate
            }}</a>
          {{ "to verify using Authenticator app instead" | translate }}
        </h6>
      </div>
    </div>
  </div>
</div>
<!-- MFA Popup End -->

<!-- MFA Popup  3 -->
<!-- Button trigger modal -->
<button [hidden]="true" id="openMFARegistrationButton" type="button" class="btn btn-primary" data-bs-toggle="modal"
  data-bs-target="#mfaModal3">
  Enter Code
</button>
<!-- Modal -->
<div class="modal fade blured-overlay" id="mfaModal3" tabindex="-1" aria-labelledby="mfaModal3Label" aria-hidden="true"
  data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog modal-dialog-centered" style="width: 50vw">
    <div class="modal-content">
      <div class="modal-header min-h-5em py-3 eod-bg-white border-0">
        <div class="w-97pc mt-3">
          <h1 class="modal-title f-24 fw-700" id="mfaModal3Label">
            {{"authenticate_by_following_these_steps_on_phone" | translate}}
          </h1>
        </div>
        <button id="closeMFARegistrationModel" type="button" class="btn-close mt-3" data-bs-dismiss="modal"
          aria-label="Close"></button>
      </div>
      <div class="modal-body w-95pc mx-auto heightCalc-15 overflow-auto border rounded onboarding mb-3">
        <h6 class="info-text">
          <span class="fw-600 min-w-4em">{{"authenticator_step_1"| translate}}</span>
          <span>{{"scan_below_qr_code_with_any" | translate}}</span>
        </h6>
        <div class="border-bottom mb-2">
          <h6 class="info-text mb-0 border-0">
            <span class="fw-600 min-w-4em">Step 2 :</span>
            <span>{{"add_your_account_to_the_app"| translate}}</span>
          </h6>
          <div class="d-flex justify-content-center mb-2">
            <img [src]="qrCodeUrl" alt="Scan QR code with your authenticator app" width="150px"/>
          </div>
        </div>
        <h6 class="info-text border-0">
          <span class="fw-600 min-w-4em">Step 3 :</span>
          <span>{{"enter_six_digit_code"| translate}}</span>
        </h6>
        <input type="text" class="form-control form-input mb-2" [(ngModel)]="qrToken" />
        <button type="button" class="btn eod-btn-secondary" (click)="verifyMFARegistrationToken()">
          {{"verify_login" | translate}}
        </button>
      </div>
      <div class="modal-footer">
        <h6 class="f-16">
          {{"having_problems" | translate}}<a data-href="javascript:void(0)" (click)="resendOTP()"
            class="eod-link-primary mx-auto f-16">
            {{"verify_using_email_instead"| translate}}</a>
        </h6>
      </div>
    </div>
  </div>
</div>
<!-- MFA Popup End -->
